import React, { useState } from "react";
import { Paper, Typography, Grid, IconButton,Tooltip } from "@mui/material";
import { PrintUserRouteDoc } from "../../../services/UserRoutesService";
import { NotificationManager } from "react-notifications";
import CommonLoader from "../../common/CommonLoader";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";

const ViewUserRoute = ({ route }) => {
  const [loading, setLoading] = useState(false);
  if (!route) {
    return null;
  }

  const handleDocumentPrint = async () => {
    setLoading(true);
    try {
      await PrintUserRouteDoc(route.id);
      NotificationManager.success("CoCs downloaded successfully");
      setLoading(false);
    } catch (error) {
      NotificationManager.error(
        "Error generating CoC:",
        error.message || error
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Paper elevation={3} style={{ padding: "16px" }}>
        <Typography variant="h6" gutterBottom>
          Route Details
        </Typography>

        <div style={{ minWidth: "120px" }}>
          <Tooltip title="Print Pickup Routes Details">
            <IconButton
              aria-label="done"
              style={{ color: "#0eed25" }}
              onClick={() => handleDocumentPrint()}
            >
              <LocalPrintshopIcon />
            </IconButton>
          </Tooltip>
        </div>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="subtitle1">
              <strong>Route Name:</strong> {route.routeName}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">
              <strong>Route Date:</strong>{" "}
              {new Date(route.routeDate).toLocaleDateString()}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">
              <strong>Route Clients:</strong> {route.routeClients || "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1">
              <strong>Route Comments:</strong> {route.routeComments || "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">
              <strong>Send Route Email:</strong> {route.sendRouteEmail ? "Yes" : "No"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">
              <strong>Completed:</strong> {route.isCompleted ? "Yes" : "No"}
            </Typography>
          </Grid>
          {route.isCompleted && (
            <Grid item xs={6}>
              <Typography variant="subtitle1">
                <strong>Completed At:</strong>{" "}
                {new Date(route.completedAt).toLocaleString()}
              </Typography>
            </Grid>
          )}
          {route.completedBy && (
            <Grid item xs={6}>
              <Typography variant="subtitle1">
                <strong>Completed By:</strong> {route.completedBy}
              </Typography>
            </Grid>
          )}
          <Grid item xs={6}>
            <Typography variant="subtitle1">
              <strong>Created At:</strong>{" "}
              {new Date(route.createdAt).toLocaleString()}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">
              <strong>Created By:</strong> {route.createdBy}
            </Typography>
          </Grid>
          {route.modifiedAt && (
            <Grid item xs={6}>
              <Typography variant="subtitle1">
                <strong>Modified At:</strong>{" "}
                {new Date(route.modifiedAt).toLocaleString()}
              </Typography>
            </Grid>
          )}
          {route.modifiedBy && (
            <Grid item xs={6}>
              <Typography variant="subtitle1">
                <strong>Modified By:</strong> {route.modifiedBy}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Paper>
      <CommonLoader loading={loading} />
    </>
  );
};

export default ViewUserRoute;
